import { createLocalNucleusForm, createReduxNucleusForm, nucleusFormShape } from '../NucleusForm';

import React from 'react';
import PropTypes from 'prop-types';
import storeShape from '../utils/storeShape';
import { omit } from 'lodash';

/**
 * Creates a form component tied to a specific form. The form acts as a
 * provider for children to interact with the form via the nucleusForm context.
 * Any wrapped inputs will be tied to the form.
 * To submit the form use the withForm HOC compoenent around a component to inject
 * the submitForm action for use.
 * @param formId - The id of the form.
 * @param formSelector - An optional selector into the larger redux state where
 *        the form exists. If not provided the nucleus form will be created
 *        with a local form.
 */
export const createForm = (formId, formSelector) => {
  return class Form extends React.Component {
    static displayName = 'Form'
    static contextTypes = {
      store: storeShape
    }
    static childContextTypes = {
      nucleusForm: nucleusFormShape
    }
    static propTypes = {
      children: PropTypes.any,
      store: storeShape,
      // Object to use instead of creating own instance of NucleusForm. Intended for testing only.
      nucleusForm: PropTypes.object
    }
    constructor(props, context) {
      super(props, context);
      const store = props.store || context.store;
      if (formSelector && !store) {
        throw new Error(
          'Could not find "store" in either the context or props of ' +
          '"Form". Either wrap the root component in a <Provider>, ' +
          'or explicitly pass "store" as a prop to "Form".');
      }
      this.nucleusForm = props.nucleusForm || (formSelector
        ? createReduxNucleusForm(formId, store, formSelector)
        : createLocalNucleusForm(formId));
    }
    getChildContext() {
      return { nucleusForm: this.nucleusForm };
    }
    render() {
      return (
        <div {...omit(this.props, ['nucleusForm'])}>
          {this.props.children}
        </div>
      );
    }
  };
};

const LocalForm = createForm('LocalForm');
export default LocalForm;
